import {  MediaPlayerController } from 'stimulus-library'
/**
 * @description Stimulus controller for use with larger videos:
 * - To initiate autoplay on page load
 * - To stop video download on page unload
 *
 * This is necessary because using autoplay: true on a video tag during turbo frame pagination (for example in a
 * carousel) will cause the previous video and the current video to download simultaneously. This results from turbo
 * caching the previous frame when loading a new one. Caching the old frame via `node.clone` causes the download to
 * begin.
 *
 * This controller must also stop previous video downloads when the video element is removed from the DOM. Without this
 * step, the video will continue to download in the background, causing the current relevant video to load more slowly.
 */
export default class PlaybackController extends MediaPlayerController {

  disconnect() {
    this.cleanupVideo()
    super.disconnect()
  }

  cleanupVideo() {
    this.mediaTarget.pause();
    this.mediaTarget.removeAttribute("src");
    this.mediaTarget.load();
  }
}